import { render, staticRenderFns } from "./qaItem1.vue?vue&type=template&id=7863427c&"
import script from "./qaItem1.vue?vue&type=script&lang=js&"
export * from "./qaItem1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7863427c')) {
      api.createRecord('7863427c', component.options)
    } else {
      api.reload('7863427c', component.options)
    }
    module.hot.accept("./qaItem1.vue?vue&type=template&id=7863427c&", function () {
      api.rerender('7863427c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qaItem1.vue"
export default component.exports